import { render, staticRenderFns } from "./dashboard-salary.vue?vue&type=template&id=c24dce66&"
import script from "./dashboard-salary.vue?vue&type=script&lang=js&"
export * from "./dashboard-salary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports